import CaseStudiesHub from "./case-studies/CaseStudiesHub";

export { Page }

function Page() {
  return <CaseStudiesHub />;
}
